<div class="area-meta">
  <div class="row">
    <app-number [formGroup]="$safeNavigationMigration(model()?.meta.formGroup)" [model]="$safeNavigationMigration(model()?.type?.data?.maxLength)" [meta]="metaMaxLength"></app-number>
  </div>
  <div class="row">
    <app-number [formGroup]="$safeNavigationMigration(model()?.meta.formGroup)" [model]="$safeNavigationMigration(model()?.type?.data?.rows)" [meta]="metaRows"></app-number>
  </div>
</div>
